import { render, staticRenderFns } from "./BatchFormField.vue?vue&type=template&id=53ffc97e&"
import script from "./BatchFormField.vue?vue&type=script&lang=js&"
export * from "./BatchFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ffc97e')) {
      api.createRecord('53ffc97e', component.options)
    } else {
      api.reload('53ffc97e', component.options)
    }
    module.hot.accept("./BatchFormField.vue?vue&type=template&id=53ffc97e&", function () {
      api.rerender('53ffc97e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/BatchFormField.vue"
export default component.exports